export default "__VITE_ASSET__DROkNvjU__"